import React from 'react'
import ReactHtmlParser from 'react-html-parser';
import { checkVariablesListForValue, getObject, phoneStandardView, priceStandardView, translate } from '../../utils/useful';
import moment from 'jalali-moment';
// import TextEditorInput from '../inputs/TextEditorInput';
import Notebooksheet from '../../windows/Notebooksheet';

class TextWidget extends React.Component {
    state = {
        data: ''
    }


    componentDidMount() {
        this.init()
    }

    componentDidUpdate(prevProps) {

        // console.log(this.props.params)
        if (this.props.data?.content != this.state.rawData || this.props.params != prevProps.params) {
            this.init()
        }
    }


    init() {

        this.setState({ rawData: this.props.data?.content })
        // console.log("this.init")
        // console.log(this.props.fullData)
        // console.log(this.props.headers)

        // console.log(this.props.data?.content)
        // console.log('this.props.data?.contentl',this.props.data?.content)
        let data = this.props.data?.content ?? '<span>Enter text ...</span>'
        let finalData
        // console.log(this.props.fullData, data, this.props.headers)
        if (data) {

            // console.log('this.props.fullData', this.props.fullData,data, this.props.headers)
            // console.log('param?.info', this.props.params)

            finalData = this.textVariableReplacer(this.props.fullData, data, this.props.headers, 'Current Record')
            // console.log('this.props.paramscs', this.props.params)
            // console.log('data After', data)

            // console.log(data)

            if (Array.isArray(this.props.params)) {
                for (let i = 0; i < this.props.params.length; i++) {
                    const param = this.props.params[i];
                    // console.log('param',param?.info, data, param?.fields, param?.label)
                    finalData = this.textVariableReplacer(param?.info, data, param?.fields, param?.label)
                    // console.log(data)

                }
            }



            if (finalData) {
                finalData = ReactHtmlParser(finalData)
            }


            this.setState({ data: null }, () => {
                this.setState({ data: finalData })

            })
        } else {

            data = ReactHtmlParser('<span>Enter text ...</span>')

            this.setState({ data: data })
        }
    }

    // changeInputValue(target) {
    //     let value = (target.validity.valid) ? target.value : null
    //     if (value !== null) {
    //         this.props.changeValue(this.props.header.key, value)
    //     }
    // }



    changeValue = (value) => {
        // console.log("changeValue")
        // console.log(value)
        this.props.changeValue(this.props.header.key, value, this.props.extra)
    }


    textVariableReplacer = (data, content, fields, preLabel) => {

        // console.log('data', content, data)
        if (content && typeof content == 'string') {

            let output = content

            let reg = new RegExp('\{\{(.*?)\}\}', 'g')

            let matches = content.match(reg)

            // console.log(matches)
            if (matches) {

                // console.log('matches', matches)
                for (let index = 0; index < matches.length; index++) {
                    const match = matches[index];


                    let key = match.replace(/{/g, '').replace(/}/g, '')
                    let found


                    // console.log('keyis', key,fields)
                    // console.log('fields', fields)
                    if (fields) {

                        for (let j = 0; j < fields.length; j++) {
                            const header = fields[j];

                            let label = header.information?.label
                            if (typeof label == 'string' && label.includes('{{lang}}')) {
                                label = header.information?.label.replace('{{lang}}', '')
                            }

                            if (preLabel) {
                                label = preLabel + ' - ' + label
                            }

                            // console.log('preLabel', preLabel)

                            let headerLabel = header.information?.label
                            if (typeof headerLabel == 'string' && headerLabel.includes('{{lang}}')) {
                                headerLabel = header.information?.label.replace('{{lang}}', '')
                            }
                            // headerLabel
                            if (key == headerLabel || key == label || key == header.key) {

                                found = true
                                // console.log("FOUND", headerLabel)

                                let value = getObject(data, header.key)
                                if (value == null) {
                                    value = getObject(data, 'values.' + header.key)
                                }

                                // console.log("VALUE", value)
                                if (value != null) {


                                    value = this.convertValueToStringFormat(value, header)
                                    // console.log("VALUE11", value)


                                    let nreg = new RegExp(match, 'g')
                                    output = output.replace(nreg, value)
                                } else {
                                    let nreg = new RegExp(match, 'g')
                                    output = output.replace(nreg, '')
                                }

                            }


                        }
                    }

                    // console.log("output",found, output)
                    if (!found) {

                        // console.log('key **', key)

                        let foundInParams = checkVariablesListForValue(this.props.params, key, ' - ')

                        // console.log('foundInParams', foundInParams)

                        if (foundInParams?.data) {
                            let value = this.convertValueToStringFormat(foundInParams?.data, foundInParams?.field)

                            let nreg = new RegExp(match, 'g')
                            output = output.replace(nreg, value)
                        } else {
                            let nreg = new RegExp(match, 'g')
                            output = output.replace(nreg, '')
                        }
                        // console.log('foundInParams', foundInParams)
                    }
                }
            }

            return output

        }

    }



    convertValueToStringFormat = (value, field) => {


        // console.log("field.type", field.type)
        switch (field.type) {
            case "PriceInput":
                value = priceStandardView(value)
                break;

            case "NumberInput":
                value = priceStandardView(value)
                break;

            case "PhoneInput":
                value = phoneStandardView(value)
                break;



            case "AddressInput":
                value = `${value?.address ?? ''} ${value?.address2 ?? ''} ${value?.city ?? ''} ${value?.cashed?.state?.title ?? ''} ${value?.cashed?.country?.title ?? ''} ${value?.zipCode ?? ''}`
                break;

            case "DateInput":
                let format = 'DD MMM YYYY'
                // console.log(this.props.variables)
                if (this.props.variables?.appletSettings?.calendarType == 'jalali') {
                    format = 'jYYYY/jM/jD'
                }
                if (field.information?.showHour) {
                    format = format + ' hh:mm'
                }

                let tempValue = isNaN(value) ? value : Number(value)

                if (moment(tempValue).isValid()) {
                    value = moment(tempValue).format(format)
                } else {
                    value = translate('Invalid date')
                }
                break;

            case "DateTimeInput":
                let mformat = 'DD MMM YYYY'
                if (field.information?.showHour) {
                    mformat = mformat + ' hh:mm'
                }
                if (moment(Number(this.props.data)).isValid()) {

                }
                value = moment(Number(value)).format(mformat)
                break;


            default:
                break;
        }
        // console.log("value VA:", value)
        return value

    }


    render() {

        let styleInfo = this.props.header?.information?.style

        if (this.state.data || this.props.editMode) {
            return (
                <div className="w-100 h-100 d-flex flex-column" style={{ alignItems: this.props.justifyContent }}>

                    {!this.props.editMode && (
                        <div className='d-flex ' style={{ border: "none", outline: "none", position: "relative", zIndex: 0, padding: styleInfo?.padding }} >
                            {this.state.data}
                        </div>
                    )}
                    {this.props.editMode && (
                        <Notebooksheet ref={el => this.noteEditor = el} header={this.props.header} data={this.props.data?.content} id={this.props.editorId ?? this.state.editorId} changeValue={this.changeValue} updateTextEffectsStyleStatus={this.props.updateTextEffectsStyleStatus} justifyContent={this.props.justifyContent} />
                    )}
                </div>
            )
        } else {
            return (
                <></>
            )
        }
    }
}

export default TextWidget;